import { type CountryCode } from 'libphonenumber-js';

import { type CompanyType } from '../customer/customer.types';

export interface MemberCountryRaw {
  countryIso3: string;
  countryIso2: string;
  countryName: string;
}

export interface MemberCountry {
  codeISO2: CountryCode | undefined;
  codeISO3: string;
  name: string;
  phoneAreaCode: string;
}

export interface Company {
  companyName: string;
  companyEmail?: string;
  companyMobile?: string;
  companyCountry?: MemberCountry;
  companyType: CompanyType;
}

export enum MemberGender {
  male = 'male',
  female = 'female',
}

export type Identifier = 'phone' | 'email';

export enum Identifiers {
  PHONE = 'phone',
  EMAIL = 'email',
}

export interface IdentifierRequestBody {
  location: CountryCode;
  value: string;
}

export interface OTPBody {
  memberId: string;
  identifierValue: string;
  otpCode: string;
  location: string;
}

export interface OTPValidationResponse {
  id: Identifier;
  value: string;
  errorStatus?: number;
}

export interface MemberSearchRequestBody {
  storeId: number;
  subjectValue: string;
  location: CountryCode;
}
